import { jsx } from 'react/jsx-runtime';
import { usePayPalScriptReducer, PayPalButtons } from '@paypal/react-paypal-js';
import { Skeleton } from '@zooplus/ui-components';
import { usePayPalButtonContext } from '../../../providers/PayPalButtonContextProvider.js';

const PayPalButton = ({ createOrder, createVaultSetupToken, style, onClick, onError, }) => {
    const [{ isResolved }] = usePayPalScriptReducer();
    const { onApprove, onCancel, isButtonDisabled } = usePayPalButtonContext();
    const fundingSource = 'paypal';
    // Render a loading skeleton if the PayPal Javascript SDK is not yet loaded and resolved
    if (!isResolved) {
        return jsx(Skeleton, {});
    }
    return (jsx(PayPalButtons, { fundingSource: fundingSource, onClick: onClick, createOrder: createOrder, onApprove: onApprove, onError: onError, onCancel: onCancel, style: style, createVaultSetupToken: createVaultSetupToken, disabled: isButtonDisabled }));
};

export { PayPalButton as default };
//# sourceMappingURL=PayPalButton.js.map
